import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.10.1_@types+node@18.19.14_eslint@8.56.0_rollup@4.13.0_sass@1.70.0_stylelint@14.16.1_ty_mhc4bqq2yvox7vbsgnq2szlqem/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}